import React, { useCallback, useEffect, useMemo } from 'react'
import { selectAccountId } from '../../../../store/auth/authSlice'
import { useAppSelector } from '../../../../store/hooks'
import { IntegrationServiceId } from '../../../../common/integrations'
import { useGetAccountQuery } from '../../../../store/accountUserSettings/accountUserSettings'
import { IntegrationSetupConfig } from '../../../../models/Account'
import { BaseSSOIntegrationConnector } from './BaseSSOIntegrationConnector'

interface RedirectHandlerProps {
  serviceId: IntegrationServiceId
  onConnected: () => void
  config: IntegrationSetupConfig
}

const OutlookSSORedirectHandler: React.FC<RedirectHandlerProps> = ({ serviceId, onConnected, config }) => {
  useEffect(() => {
    if (config?.url) {
      if (config.openInNewTab) {
        window.open(config.url, '_blank', 'noopener noreferrer')
      } else {
        window.location.href = config.url
      }
      onConnected()
    }
  }, [config, onConnected, serviceId])

  return null
}

interface OutlookCalendarSSOIntegrationConnectorProps {
  serviceId: IntegrationServiceId
  startConnect: boolean
  onConnected: () => void
}

export const OutlookCalendarSSOIntegrationConnector: React.FC<OutlookCalendarSSOIntegrationConnectorProps> = ({ serviceId, startConnect, onConnected }) => {
  const accountId = useAppSelector(selectAccountId)
  const { data: account } = useGetAccountQuery({ accountId })

  const integrationSetupConfigs = useMemo(() => account?.data?.enterpriseConfig.integrationsConfig.integrationSetupConfigs ?? [], [account])

  const config = integrationSetupConfigs.find((cfg) => cfg.integration === serviceId)

  const baseSSOIntegrationConnector = useCallback(
    () => BaseSSOIntegrationConnector({ serviceId, startConnect, onConnected, stateStep: null }),
    [serviceId, startConnect, onConnected],
  )

  if (startConnect && accountId && config?.url) {
    return <OutlookSSORedirectHandler serviceId={serviceId} onConnected={onConnected} config={config} />
  }
  return baseSSOIntegrationConnector()
}
